export default __webpack_public_path__ + "static/media/5g.4997847c.svg";